<template>
  <div class="disclaimer-page">
    <div class="page-inner">
      <h1>{{ $t("disclaimer.title") }}</h1>
      <p class="disclaimer-text">{{ $t("disclaimer.content") }}</p>
      <p class="email-link">
        <a :href="'mailto:' + $t('disclaimer.email')">{{
          $t("disclaimer.email")
        }}</a>
        <i class="fas fa-external-link-alt"></i>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DisclaimerPage",
};
</script>

<style lang="scss" scoped>
.disclaimer-page {
  flex: 1;
  padding: 40px 0;
  min-height: 400px;
}

.page-inner {
  max-width: $max-width;
  margin: 0 auto;
  padding: 0 24px;

  h1 {
    font-size: 28px;
    color: $primary-orange;
    margin-bottom: 20px;
  }
}

.disclaimer-text {
  font-size: 16px;
  line-height: 1.8;
  color: $text-dark;
  margin-bottom: 12px;
  letter-spacing: 1px;
}

.email-link {
  a {
    color: $primary-orange;
    text-decoration: underline;

    &:hover {
      color: darken(#e87722, 10%);
    }
  }

  i {
    font-size: 12px;
    color: $primary-orange;
    margin-left: 4px;
  }
}

.lang-en .disclaimer-page {
  .disclaimer-text {
    letter-spacing: 0px;
  }

  h1 {
    letter-spacing: 0px;
  }
}
</style>
